import React, { useRef, useState, useEffect, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import withPasteUpload from "@rpldy/upload-paste";
import Uploady from "@rpldy/uploady";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const logo = require("./../assets/img/logo.svg").default;
const demoImg = require("./../assets/img/demo-img.png");
const companyLogo = require("./../assets/img/company-logo.svg").default;
const viewImg = require("./../assets/img/viewImg.png");
const backBtn = require("./../assets/img/back-btn.svg").default;
const CrossBtn = require("./../assets/img/cross-icon.svg").default;

const PreviewForm = () => {
  const imageDivRef = useRef();
  const navigate = useNavigate();
  const { form_key } = useParams(); // Get the file name from route params

  const [selectedImages, setSelectedImages] = useState([]);
  const [isScrollBottom, setIsScrollBottom] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [dateValue, setDateValue] = useState("");
  const [draggingOver, setDraggingOver] = useState(false);
  const [dragEnabled, setDragEnabled] = useState(true);
  const [errorMsg, setErrorMsg] = useState();
  const [showViewImg, setShowViewImg] = useState(true);

  const [userData, setUserData] = useState(null);
  const [fileDetails, setFileDetails] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [pdfData, setPdfData] = useState(null);
  const [labels, setLabels] = useState([]);
  const [dateFormat, setDateFormat] = useState([]);
  const [prevImages, setPrevImages] = useState([]);
  const [deletedTempImages, setDeletedTempImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [insuredValue, setInsuredValue] = useState();
  const [representiveValue, setRepresentiveValue] = useState();
  const [isAcceptedCheckbox, setIsAcceptedCheckbox] = useState(null);
  const [isRetunedCheckbox, setIsRetunedCheckbox] = useState(null);
  const [validationMsg, setValidationMsg] = useState();
  const [dateForShow, setDateForShow] = useState();
  const [successMsg, setSuccessMsg] = useState();
  const [status, setStatus] = useState();
  const [signImage, setSignImage] = useState();
  const insuredValueRef = useRef(null);
  const representiveValueRef = useRef(null);
  const isAcceptedCheckboxRef = useRef(null);
  const [inputClassName, setInputClassName] = useState("");
  const [isSignatureValid, setIsSignatureValid] = useState(false);
  const [senderEmail, setSenderEmail] = useState();
  const [notScrolledError, setNotScrolledError] = useState("");

  const formDataFetch = () => {
    fetch(`https://cliqestimatebuilder.com/waiver_admin/forms/${form_key}`)
      .then((response) => response.json())
      .then((data) => {
        // Assuming data.images is an array of image URLs, you can set it to selectedImages
        setPdfData(data.images);
        setStatus(data.status);
        //setLabels(data.labels); // Assuming data.labels is an array of labels
        setUserData(data);
        const orderDate = data.input_values[7];
        const dateObject = new Date(orderDate);
        const formattedDate = `${dateObject.getDate()}/${
          dateObject.getMonth() + 1
        }/${dateObject.getFullYear()}`;

        // Now you can use the formattedDate variable where you need it
        setDateFormat(formattedDate);

        const newImages = [];
        for (let i = 0; i < data.images.length; i++) {
          data.images[i].image =
            "https://cliqestimatebuilder.com/waiver_admin/" +
            data.images[i].image;
          newImages.push(data.images[i]);
          // newImages.push("https://cliqestimatebuilder.com/waiver_admin/" + data.images[i].image);
        }
        setPrevImages(newImages);
        let tempArray = [];
        tempArray.push(data.labels, data.input_values);
        setFileDetails(tempArray);
        if (data.labels.includes("Insured Value")) {
          let index = data.labels.findIndex((item) => item == "Insured Value");
          setInsuredValue(data.input_values[index]);
        } else {
        }
        if (data.labels.includes("signed_representive")) {
          let index = data.labels.findIndex(
            (item) => item == "signed_representive"
          );
          setRepresentiveValue(data.input_values[index]);
        } else {
        }
        if (data.labels.includes("signed_date")) {
          let index = data.labels.findIndex((item) => item == "signed_date");
          setDateValue(data.input_values[index]);
          let splitVal = data.input_values[index]?.split("-");
          console.log(data.input_values[index]);
          console.log(splitVal);
          setDateForShow(splitVal[1] + "-" + splitVal[2] + "-" + splitVal[0]);
        } else {
          const currentDate = new Date();

          // Get the year, month, and day components
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Add 1 to the month because it's zero-based
          const day = String(currentDate.getDate()).padStart(2, "0");
          // Create the YMD formatted date string
          const ymdDate = `${year}-${month}-${day}`;
          setDateValue(ymdDate);
          setDateForShow(month + "-" + day + "-" + year);
        }
        if (data.is_accepted) {
          setIsAcceptedCheckbox(data.is_accepted);
        } else {
        }
        if (data.is_returned) {
          setIsRetunedCheckbox(data.is_returned);
        } else {
        }
        setSignImage(data.sign);
      })
      .catch((error) => {
        console.error("Error fetching file details:", error);
      });
  };

  useEffect(() => {
    formDataFetch();
  }, [form_key]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleDateChange = (event) => {
    setDateValue(event.target.value);
    if (event.target.value) {
      let splitVal = event.target.value?.split("-");
      setDateForShow(splitVal[2] + "-" + splitVal[1] + "-" + splitVal[0]);
    }
  };

  const handleImageChange = (event) => {
    // const files = event.target.files;
    // const fileArray = Array.from(files);
    // setSelectedImages((prevSelectedImages) => [
    //   ...prevSelectedImages,
    //   ...fileArray,
    // ]);

    event.preventDefault();
    const files = event.target.files;
    const newImages = [...selectedImages];
    for (let i = 0; i < files.length; i++) {
      if (files[i] && isImageFile(files[i])) {
        newImages.push(files[i]);
        // You can now upload or process the pasted file
        setErrorMsg(null);
      } else {
        setErrorMsg("Upload valid images. Only PNG and JPEG are allowed.");
        setTimeout(() => {
          setErrorMsg(null);
        }, 2000);
      }
    }
    setSelectedImages(newImages);
    event.target.value = null;
  };

  const handleRemoveImage = (index) => {
    const updatedImages = [...selectedImages];
    updatedImages.splice(index, 1);
    setSelectedImages(updatedImages);
  };

  const handleRemoveExistImage = (index, id) => {
    const updatedImages = [...prevImages];
    let deletedImage = updatedImages.find(
      (item) => Number(item.id) === Number(id)
    );
    setDeletedTempImages([...deletedTempImages, deletedImage]);
    updatedImages.splice(index, 1);
    setPrevImages(updatedImages);
  };

  const handleCrossFirstClick = () => {
    setShowViewImg(false);
  };

  const signatureRef = useRef();
  const [canvasSize, setCanvasSize] = useState({
    width: 650,
    height: 200,
  });

  const handleClear = () => {
    signatureRef.current.clear();
  };

  const handleSave = () => {
    const signatureData = signatureRef.current.toDataURL();
  };

  const handleScroll = () => {
    const viewContent = document.querySelector(".acknw");
    const errorElement = document.querySelector(".ccc");
    if (viewContent) {
      const { scrollTop, scrollHeight, clientHeight } = viewContent;
      const isBottom = scrollTop + clientHeight >= scrollHeight - 10; // Adding a small offset

      if (errorElement) {
        if (isBottom) {
          setNotScrolledError("");
          errorElement.style.display = "none"; // Hide the .ccc element
        } else {
          errorElement.style.display = "block"; // Show the .ccc element
        }
      }

      setIsScrollBottom(isBottom);
    }
  };

  const isImageFile = (file) => {
    // Define accepted image MIME types
    const acceptedImageTypes = ["image/jpeg", "image/png"];

    // Check if the file's MIME type is in the accepted types array
    return acceptedImageTypes.includes(file.type);
  };

  const handleChangeImage = (e) => {
    e.preventDefault();
    const files = e.target.files;
    const newImages = [...selectedImages];
    for (let i = 0; i < files.length; i++) {
      if (files[i] && isImageFile(files[i])) {
        newImages.push({ file: files[i], uri: URL.createObjectURL(files[i]) });
        // You can now upload or process the pasted file
        setErrorMsg(null);
      } else {
        setErrorMsg("Upload valid images. Only PNG and JPEG are allowed.");
        setTimeout(() => {
          setErrorMsg(null);
        }, 2000);
      }
    }
    setSelectedImages(newImages);
    e.target.value = null;
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    const newImages = [...selectedImages];
    for (let i = 0; i < files.length; i++) {
      if (files[i] && isImageFile(files[i])) {
        // newImages.push({ file: files[i], uri: URL.createObjectURL(files[i]) });
        newImages.push(files[i]);
        // You can now upload or process the pasted file
        setErrorMsg(null);
      } else {
        setErrorMsg("Upload valid images. Only PNG and JPEG are allowed.");
        setTimeout(() => {
          setErrorMsg(null);
        }, 2000);
      }
    }
    setSelectedImages(newImages);
    setDraggingOver(false);
    setDragEnabled(false);
    e.target.value = null;
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDraggingOver(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDraggingOver(true);
  };

  const handleDragLeave = () => {
    setDraggingOver(false);
  };

  const PasteArea = withPasteUpload(({ onPasteUpload }) => {
    return (
      <div
        style={{
          width: "400px",
          height: "400px",
          border: "2px dashed #000", // Add a dashed border for visualization
          display: "none",
          alignItems: "center",
          justifyContent: "center",
        }}
        onPaste={onPasteUpload}
      >
        Paste file here to upload
      </div>
    );
  });

  const onPasteUpload = useCallback((event) => {
    event.preventDefault(); // Prevent the default paste behavior
    const clipboardData = event.clipboardData || window.clipboardData;
    const newImages = [];

    if (clipboardData && clipboardData.items) {
      for (let i = 0; i < clipboardData.items.length; i++) {
        const item = clipboardData.items[i];
        if (item.kind === "file") {
          const file = item.getAsFile();
          if (file && isImageFile(file)) {
            //newImages.push({ file: file, uri: URL.createObjectURL(file) });
            newImages.push(file);
            // You can now upload or process the pasted file
            setErrorMsg(null);
          } else {
            setErrorMsg("Upload valid images. Only PNG and JPEG are allowed.");
            setTimeout(() => {
              setErrorMsg(null);
            }, 2000);
          }
        }
      }
    }

    setSelectedImages((prevImages) => [...prevImages, ...newImages]); // Merge old and new images
    event.target.value = null;
  }, []);

  const generatePDF = (callback) => {
    const inputElement = document.querySelector(".previewPopupInner");

    html2canvas(inputElement, { scale: 1 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      pdf.addImage(imgData, "PNG", 0, 0, 210, 297); // Adjust the size as needed
      pdf.save("preview.pdf");

      // Get the PDF binary data
      //const pdfData = pdf.output("arraybuffer");

      //callback(pdfData); // Pass the PDF binary data to the callback function
    });
  };

  const onFinalSubmit = () => {
    const signatureIsEmpty = signatureRef.current.isEmpty();
    // You can now save or use the signatureData as needed.
    console.log(signatureIsEmpty);

    if (!signatureIsEmpty) {
      setIsSignatureValid(true);
    } else {
      setIsSignatureValid(false);
      setValidationMsg("Please provide a signature.");
    }
    const dataURL = signatureRef.current.toDataURL();

    // Convert the data URL to a Blob
    const blob = dataURLToBlob(dataURL);
    // Create a File object from the Blob
    const signedfile = new File([blob], "signature.png", { type: "image/png" });

    if (!insuredValue) {
      setValidationMsg("Insured value is required.");

      setTimeout(() => {
        insuredValueRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 500);
      setInputClassName("invalid-input");

      return;
    } else if (!representiveValue) {
      setValidationMsg("Authorized Representative is required.");

      setTimeout(() => {
        representiveValueRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 500);

      setInputClassName("invalid-input");
      return;
    } else if (!dateValue) {
      setValidationMsg("Authorized date is required.");
      return;
    } else if (!isAcceptedCheckbox) {
      setValidationMsg("Please accept or decline terms above");

      setTimeout(() => {
        isAcceptedCheckboxRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 500);
      setInputClassName("invalid-input");

      return;
    } else if (signatureIsEmpty) {
      setValidationMsg("Please provide a signature.");
      return;
    } else {
      setLoading(true);
      setValidationMsg("");
      setInputClassName("");
      const storedUserData = JSON.parse(localStorage.getItem("userData"));

      // Create a FormData object to send the PDF file to the API

      const formData = new FormData();

      // return;
      fileDetails[0] &&
        Object.entries(fileDetails[0]).forEach(([label, value]) => {
          formData.append("labels[]", value);
          formData.append("input_values[]", fileDetails[1][label]);
        });
      if (insuredValue) {
        formData.append("labels[]", "Insured Value");
        formData.append("input_values[]", insuredValue);
      }
      if (representiveValue) {
        formData.append("labels[]", "signed_representive");
        formData.append("input_values[]", representiveValue);
      }
      if (representiveValue) {
        formData.append("labels[]", "signed_date");
        formData.append("input_values[]", dateValue);
      }
      selectedImages.forEach((image, index) => {
        formData.append("images[]", image);
      });
      formData.append("sign", signedfile);
      formData.append("form_key", form_key);
      formData.append(
        "is_accepted",
        isAcceptedCheckbox ? isAcceptedCheckbox : ""
      );
      formData.append(
        "is_returned",
        isRetunedCheckbox ? isRetunedCheckbox : ""
      );
      formData.append("signed_representive", representiveValue);
      formData.append("signed_date", dateValue);
      console.log(isAcceptedCheckbox);
      console.log(isRetunedCheckbox);
      console.log(representiveValue);
      console.log(dateValue);
      //generatePDF((pdfData) => {
      formData.append("pdf_file", new Blob([pdfData]), "preview.pdf");
      fetch(`https://cliqestimatebuilder.com/waiver_admin/forms/update`, {
        method: "POST",
        body: formData,
        // headers: {
        //   Authorization: `Bearer ${storedUserData.token}`,
        // },
      })
        .then((response) => response.json())
        .then((data) => {
          setLoading(false);
          if (data.res == "1") {
            const secondFormData = new FormData();
            secondFormData.append("email_address", data.data.email);
            secondFormData.append("pdf", data.data.pdf);
            secondFormData.append("ship_within", userData?.ship_within);

            fetch(
              `https://cliqestimatebuilder.com/matrix_admin/sendwaiverpdf/`,
              {
                method: "POST",
                body: secondFormData,
              }
            )
              .then((secondResponse) => secondResponse.json())
              .then((secondData) => {})
              .catch((secondError) => {
                console.error("Error in the second request:", secondError);
                // Handle the error for the second request
              });
            //setSuccessMsg(data.msg);
            formDataFetch();
            // navigate("/after-submitted-form", {state: {email: senderEmail}});
            if (deletedTempImages.length > 0) {
              deletedTempImages.forEach((elem, key) => {
                fetch(
                  `https://cliqestimatebuilder.com/waiver_admin/form-images/${elem.id}`,
                  {
                    method: "DELETE",
                    // headers: {
                    //   Authorization: `Bearer ${storedUserData.token}`,
                    // },
                  }
                )
                  .then((response) => response.json())
                  .then((data) => {})
                  .catch((error) => {
                    console.error("Error submitting form data:", error);
                    setLoading(false);
                  });
              });
            }
          } else {
            // senderEmailError(data.msg);
            setSuccessMsg(data.msg);
          }
        })
        .catch((error) => {
          console.error("Error submitting form data:", error);
          setValidationMsg("Something went wrong. Please Try again later.");
          setLoading(false);
        });
      //});
    }
  };

  const dataURLToBlob = (dataURL) => {
    const binaryString = window.atob(dataURL?.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(binaryString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryString.length; i++) {
      uint8Array[i] = binaryString.charCodeAt(i);
    }

    return new Blob([uint8Array], { type: "image/png" });
  };

  const formDataSubmit = () => {};

  useEffect(() => {
    const acceptableTag = document.querySelector(".imgBox");
    acceptableTag.addEventListener("paste", onPasteUpload);

    return () => {
      // Remove the paste event listener when the component unmounts
      acceptableTag.removeEventListener("paste", onPasteUpload);
    };
  }, [onPasteUpload]);

  useEffect(() => {
    const handleResize = () => {
      const newCanvasSize = {
        width: window.innerWidth >= 768 ? 650 : "250",
        height: window.innerWidth >= 768 ? 200 : "130",
      };
      setCanvasSize(newCanvasSize);

      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initialize canvas size based on initial window width

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleRemoveApiImage = (index) => {
    const updatedPdfData = [...pdfData];
    updatedPdfData.splice(index, 1);
    setPdfData(updatedPdfData);
  };

  const [isImageEnlarged, setImageEnlarged] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setImageEnlarged(true);
  };

  const handleCloseEnlarged = () => {
    setImageEnlarged(false);
  };

  return (
    <div className="bodyMain">
      <div className="previewPopup formPrvwPge">
        <div className="previewPopupInner">
          <div className="lftPop">
            <img src={logo} alt="image" />
          </div>
          {/* <button onClick={generatePDF}>Download PDF</button> */}
          <div className="rgtPop">
            <h3>
              <img src={companyLogo} alt="image" />
            </h3>
            <p>211 N. 13th Street, 9th Floor, Philadelphia,PA 19107, USA</p>
            <p>
              <span>p:</span> 800.765.7111 <span>e:</span>info@cliqjewelry.com
            </p>
          </div>

          <div className="jobDtls">
            <h3>
              <span>Job: </span>
              {userData && userData.labels && userData.labels.length > 0 && (
                <>
                  {userData.labels.map((label, index) => {
                    if (label !== "Job code") {
                      return null; // Skip rendering "Order date" here
                    }
                    return (
                      <strong key={index}>
                        {userData.input_values[index]}
                      </strong>
                    );
                  })}
                </>
              )}
            </h3>
            <h3>
              <span>Date:</span> {dateForShow}
            </h3>
          </div>

          <div className="prvwForm">
            <ul className="cstmr">
              <li>
                <h3>Customer Name:</h3>
                {userData && userData.labels && userData.labels.length > 0 && (
                  <>
                    {userData.labels.map((label, index) => {
                      if (label !== "Customer") {
                        return null; // Skip rendering "Order date" here
                      }
                      return (
                        <span key={index}>{userData.input_values[index]}</span>
                      );
                    })}
                  </>
                )}
              </li>
              <li ref={insuredValueRef}>
                <h3>Insured Value:</h3>
                <input
                  type="text"
                  disabled={Number(status) === 1 ? true : false}
                  className={inputClassName}
                  placeholder="Enter value (in dollars)"
                  value={insuredValue}
                  onChange={(e) => setInsuredValue(e.target.value)}
                />
              </li>
              <li ref={representiveValueRef}>
                <h3>Authorized Representative:</h3>
                <input
                  type="text"
                  disabled={Number(status) === 1 ? true : false}
                  placeholder=""
                  className={inputClassName}
                  value={representiveValue}
                  onChange={(e) => setRepresentiveValue(e.target.value)}
                />
              </li>
              <li>
                <h3>Customer PO#</h3>

                {userData && userData.labels && userData.labels.length > 0 && (
                  <>
                    {userData.labels.map((label, index) => {
                      if (label !== "Customer PO#") {
                        return null; // Skip rendering "Order date" here
                      }
                      return (
                        <span key={index}>{userData.input_values[index]}</span>
                      );
                    })}
                  </>
                )}
              </li>
              {/* <li>
                <h3>Job description and Notes:</h3>
                Lorem Ipsum
              </li> */}

              {userData && userData.labels && userData.labels.length > 0 && (
                <>
                  {userData.labels.map((label, index) => {
                    if (
                      label !== "Contact email" &&
                      label !== "Release notes"
                    ) {
                      return null; // Skip rendering "Order date" here
                    }
                    return (
                      <li key={index}>
                        <h3>
                          {label === "Release notes"
                            ? "Job description and Notes"
                            : label}
                          :
                        </h3>
                        {userData.input_values[index]}
                      </li>
                    );
                  })}
                </>
              )}
              {Number(status) === 1 ? (
                <li className="crteForm fulWid prvwImgBox">
                  <h3>Job Images:</h3>

                  <div
                    className="imgBox"
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                  >
                    {selectedImages.length > 0 || prevImages?.length > 0 ? (
                      <div className="image-preview">
                        {prevImages?.length > 0
                          ? prevImages.map((image, index) => (
                              <div key={index} className="image-container">
                                <img
                                  src={image?.image}
                                  alt={`Uploaded ${index + 1}`}
                                  className="upImg"
                                  onClick={() => handleImageClick(image.image)}
                                />
                              </div>
                            ))
                          : null}
                        {selectedImages.map((image, index) => (
                          <div
                            key={index}
                            className="image-container"
                            onClick={() =>
                              handleImageClick(URL.createObjectURL(image))
                            }
                          >
                            <img
                              src={URL.createObjectURL(image)}
                              alt={`Uploaded ${index + 1}`}
                              className="upImg"
                            />
                          </div>
                        ))}
                      </div>
                    ) : null}
                  </div>

                  {isImageEnlarged && (
                    <div
                      className="enlarged-modal"
                      onClick={handleCloseEnlarged}
                    >
                      <div className="enlarged-modal-content">
                        <span className="close">×</span>
                        <img src={selectedImage} alt="Enlarged" />
                      </div>
                    </div>
                  )}
                  {errorMsg ? (
                    <span className="msgBrse errMsgClr">{errorMsg}</span>
                  ) : null}

                  <p className="msgBrse">
                    *Browse file or Drag and drop multiple images here
                  </p>
                </li>
              ) : (
                <li className="crteForm fulWid prvwImgBox">
                  <h3>Job Images:</h3>

                  <div
                    className="imgBox"
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                  >
                    {selectedImages.length > 0 || prevImages?.length > 0 ? (
                      <div className="image-preview">
                        {prevImages?.length > 0
                          ? prevImages.map((image, index) => (
                              <div key={index} className="image-container">
                                <img
                                  src={image?.image}
                                  alt={`Uploaded ${index + 1}`}
                                  className="upImg"
                                  onClick={() => handleImageClick(image.image)}
                                />
                              </div>
                            ))
                          : null}
                        {selectedImages.map((image, index) => (
                          <div
                            key={index}
                            className="image-container"
                            onClick={() =>
                              handleImageClick(URL.createObjectURL(image))
                            }
                          >
                            <img
                              src={URL.createObjectURL(image)}
                              alt={`Uploaded ${index + 1}`}
                              className="upImg"
                            />
                          </div>
                        ))}
                      </div>
                    ) : null}
                  </div>
                  {isImageEnlarged && (
                    <div
                      className="enlarged-modal"
                      onClick={handleCloseEnlarged}
                    >
                      <div className="enlarged-modal-content">
                        <span className="close">×</span>
                        <img src={selectedImage} alt="Enlarged" />
                      </div>
                    </div>
                  )}
                  {/* <div className="falseDiv"></div> */}
                  {errorMsg ? (
                    <span className="msgBrse errMsgClr">{errorMsg}</span>
                  ) : null}
                </li>
              )}

              <li className="HdnBck txtWid">
                <h4>Metal</h4>
              </li>
              <li className="HdnBck txtWid2">
                <h4>Finger Size</h4>
              </li>

              <li className="txtWid">
                {userData && userData.labels && userData.labels.length > 0 && (
                  <>
                    {userData.labels.map((label, index) => {
                      if (label !== "Metal") {
                        return null; // Skip rendering "Order date" here
                      }
                      return (
                        <span key={index}>{userData.input_values[index]}</span>
                      );
                    })}
                  </>
                )}
              </li>
              <li className="txtWid2">
                {userData && userData.labels && userData.labels.length > 0 && (
                  <>
                    {userData.labels.map((label, index) => {
                      if (label !== "Finger Size") {
                        return null; // Skip rendering "Order date" here
                      }
                      return (
                        <span key={index}>{userData.input_values[index]}</span>
                      );
                    })}
                  </>
                )}
              </li>
            </ul>
            <ul className="prctable">
              <li className="ttlTbl">
                <h3>
                  Total price:{" "}
                  {userData &&
                    userData.labels &&
                    userData.labels.length > 0 && (
                      <>
                        {userData.labels.map((label, index) => {
                          if (label !== "Total price") {
                            return null; // Skip rendering "Order date" here
                          }
                          return (
                            <strong key={index}>
                              {userData.input_values[index]}
                            </strong>
                          );
                        })}
                      </>
                    )}
                </h3>
              </li>
            </ul>
          </div>

          <div className="sigName">
            <div className="lftSig">
              <div className="dteHidden">
                <label>Authorized Representative:</label>
                <input
                  type="text"
                  disabled={Number(status) === 1 ? true : false}
                  placeholder=""
                  value={representiveValue}
                  onChange={(e) => setRepresentiveValue(e.target.value)}
                />
                {/* <input type="text" placeholder="Date" value={dateValue} onChange={handleDateChange} /> */}
                <input
                  type="date"
                  disabled={Number(status) === 1 ? true : false}
                  id="fromDate"
                  value={dateValue}
                  onChange={handleDateChange}
                />
              </div>
              <h4>
                {representiveValue} and{" "}
                {userData && userData.labels && userData.labels.length > 0 && (
                  <>
                    {userData.labels.map((label, index) => {
                      if (label !== "Customer") {
                        return null; // Skip rendering "Order date" here
                      }
                      return (
                        <span key={index}>{userData.input_values[index]}</span>
                      );
                    })}
                  </>
                )}
              </h4>
            </div>
            <div className="rgtSig">
              <h3>
                <span>Job: </span>
                {userData && userData.labels && userData.labels.length > 0 && (
                  <>
                    {userData.labels.map((label, index) => {
                      if (label !== "Job code") {
                        return null; // Skip rendering "Order date" here
                      }
                      return (
                        <strong key={index}>
                          {userData.input_values[index]}
                        </strong>
                      );
                    })}
                  </>
                )}
              </h3>
            </div>
          </div>

          <div className="acknw" onScroll={handleScroll}>
            <div
              dangerouslySetInnerHTML={{ __html: userData && userData.terms }}
            />
          </div>
          {Number(status !== 1) ? (
            <>
              <ul className="popFrm" ref={isAcceptedCheckboxRef}>
                {!isScrollBottom ? (
                  <>
                    <li
                      onClick={() =>
                        setNotScrolledError(
                          "Please read the 'Acknowledges receipt' information"
                        )
                      }
                    >
                      {notScrolledError ? (
                        <div className="error1">{notScrolledError}</div>
                      ) : null}
                      <div className="error2"></div>
                      <input
                        type="checkbox"
                        id="enableCheckbox"
                        disabled={!isScrollBottom}
                        checked={Number(isAcceptedCheckbox) === 1}
                        onChange={(e) =>
                          setIsAcceptedCheckbox(e.target.checked ? 1 : null)
                        }
                      />{" "}
                      I accept
                    </li>
                    <li
                      onClick={() =>
                        setNotScrolledError(
                          "Please read the 'Acknowledges receipt' information"
                        )
                      }
                    >
                      <div className="error2"></div>
                      <input
                        type="checkbox"
                        disabled={!isScrollBottom}
                        checked={Number(isAcceptedCheckbox) === 2}
                        onChange={(e) =>
                          setIsAcceptedCheckbox(e.target.checked ? 2 : null)
                        }
                      />{" "}
                      I do not accept these terms, please return my job, with no
                      work completed
                    </li>
                    <li
                      onClick={() =>
                        setNotScrolledError(
                          "Please read the 'Acknowledges receipt' information"
                        )
                      }
                    >
                      <div className="error2"></div>
                      <span>
                        <input
                          type="checkbox"
                          disabled={!isScrollBottom}
                          checked={Number(isRetunedCheckbox) === 1}
                          onChange={(e) =>
                            setIsRetunedCheckbox(e.target.checked ? 1 : null)
                          }
                        />{" "}
                        Please return all my scrap metal
                      </span>
                      <span>
                        <input
                          type="checkbox"
                          disabled={!isScrollBottom}
                          checked={Number(isRetunedCheckbox) === 2}
                          onChange={(e) =>
                            setIsRetunedCheckbox(e.target.checked ? 2 : null)
                          }
                        />{" "}
                        Please retain all scrap at rates listed:
                        <p className="mtlPara">
                          PLAT Metal Credit :{" "}
                          {userData &&
                            userData.labels &&
                            userData.labels.length > 0 && (
                              <>
                                {userData.labels.map((label, index) => {
                                  if (label !== "PLAT Metal Credit") {
                                    return null; // Skip rendering "Order date" here
                                  }
                                  return (
                                    <strong className="pltMtl" key={index}>
                                      {userData.input_values[index]}
                                    </strong>
                                  );
                                })}
                              </>
                            )}
                        </p>
                        <p className="mtlPara">
                          14K Metal Credit :{" "}
                          {userData &&
                            userData.labels &&
                            userData.labels.length > 0 && (
                              <>
                                {userData.labels.map((label, index) => {
                                  if (label !== "14K Metal Credit") {
                                    return null; // Skip rendering "Order date" here
                                  }
                                  return (
                                    <strong className="pltMtl" key={index}>
                                      {userData.input_values[index]}
                                    </strong>
                                  );
                                })}
                              </>
                            )}
                        </p>
                        <p className="mtlPara">
                          18K Metal Credit :{" "}
                          {userData &&
                            userData.labels &&
                            userData.labels.length > 0 && (
                              <>
                                {userData.labels.map((label, index) => {
                                  if (label !== "18K Metal Credit") {
                                    return null; // Skip rendering "Order date" here
                                  }
                                  return (
                                    <strong className="pltMtl" key={index}>
                                      {userData.input_values[index]}
                                    </strong>
                                  );
                                })}
                              </>
                            )}
                        </p>
                      </span>
                    </li>
                  </>
                ) : (
                  <>
                    <li>
                      <input
                        type="checkbox"
                        id="enableCheckbox"
                        disabled={!isScrollBottom}
                        checked={Number(isAcceptedCheckbox) === 1}
                        onChange={(e) =>
                          setIsAcceptedCheckbox(e.target.checked ? 1 : null)
                        }
                      />{" "}
                      I accept
                    </li>
                    <li>
                      <input
                        type="checkbox"
                        disabled={!isScrollBottom}
                        checked={Number(isAcceptedCheckbox) === 2}
                        onChange={(e) =>
                          setIsAcceptedCheckbox(e.target.checked ? 2 : null)
                        }
                      />{" "}
                      I do not accept these terms, please return my job, with no
                      work completed
                    </li>
                    <li>
                      <span>
                        <input
                          type="checkbox"
                          disabled={!isScrollBottom}
                          checked={Number(isRetunedCheckbox) === 1}
                          onChange={(e) =>
                            setIsRetunedCheckbox(e.target.checked ? 1 : null)
                          }
                        />{" "}
                        Please return all my scrap metal
                      </span>
                      <span>
                        <input
                          type="checkbox"
                          disabled={!isScrollBottom}
                          checked={Number(isRetunedCheckbox) === 2}
                          onChange={(e) =>
                            setIsRetunedCheckbox(e.target.checked ? 2 : null)
                          }
                        />{" "}
                        Please retain all scrap at rates listed:
                        <p className="mtlPara">
                          PLAT Metal Credit :{" "}
                          {userData &&
                            userData.labels &&
                            userData.labels.length > 0 && (
                              <>
                                {userData.labels.map((label, index) => {
                                  if (label !== "PLAT Metal Credit") {
                                    return null; // Skip rendering "Order date" here
                                  }
                                  return (
                                    <strong className="pltMtl" key={index}>
                                      {userData.input_values[index]}
                                    </strong>
                                  );
                                })}
                              </>
                            )}
                        </p>
                        <p className="mtlPara">
                          14K Metal Credit :{" "}
                          {userData &&
                            userData.labels &&
                            userData.labels.length > 0 && (
                              <>
                                {userData.labels.map((label, index) => {
                                  if (label !== "14K Metal Credit") {
                                    return null; // Skip rendering "Order date" here
                                  }
                                  return (
                                    <strong className="pltMtl" key={index}>
                                      {userData.input_values[index]}
                                    </strong>
                                  );
                                })}
                              </>
                            )}
                        </p>
                        <p className="mtlPara">
                          18K Metal Credit :{" "}
                          {userData &&
                            userData.labels &&
                            userData.labels.length > 0 && (
                              <>
                                {userData.labels.map((label, index) => {
                                  if (label !== "18K Metal Credit") {
                                    return null; // Skip rendering "Order date" here
                                  }
                                  return (
                                    <strong className="pltMtl" key={index}>
                                      {userData.input_values[index]}
                                    </strong>
                                  );
                                })}
                              </>
                            )}
                        </p>
                      </span>
                    </li>
                  </>
                )}
              </ul>
            </>
          ) : (
            <ul className="popFrm">
              <li>
                <input
                  type="checkbox"
                  id="enableCheckbox"
                  disabled
                  checked={Number(isAcceptedCheckbox) === 1}
                  onChange={(e) =>
                    setIsAcceptedCheckbox(e.target.checked ? 1 : null)
                  }
                />{" "}
                I accept
              </li>
              <li>
                <input
                  type="checkbox"
                  disabled
                  checked={Number(isAcceptedCheckbox) === 2}
                  onChange={(e) =>
                    setIsAcceptedCheckbox(e.target.checked ? 2 : null)
                  }
                />{" "}
                I do not accept these terms, please return my job, with no work
                completed
              </li>
              <li>
                <span>
                  <input
                    type="checkbox"
                    disabled
                    checked={Number(isRetunedCheckbox) === 1}
                    onChange={(e) =>
                      setIsRetunedCheckbox(e.target.checked ? 1 : null)
                    }
                  />{" "}
                  Please return all my scrap metal
                </span>
                <span>
                  <input
                    type="checkbox"
                    disabled
                    checked={Number(isRetunedCheckbox) === 2}
                    onChange={(e) =>
                      setIsRetunedCheckbox(e.target.checked ? 2 : null)
                    }
                  />{" "}
                  Please retain all scrap at rates listed:
                  <p className="mtlPara">
                    PLAT Metal Credit :{" "}
                    {userData &&
                      userData.labels &&
                      userData.labels.length > 0 && (
                        <>
                          {userData.labels.map((label, index) => {
                            if (label !== "PLAT Metal Credit") {
                              return null; // Skip rendering "Order date" here
                            }
                            return (
                              <strong className="pltMtl" key={index}>
                                {userData.input_values[index]}
                              </strong>
                            );
                          })}
                        </>
                      )}
                  </p>
                  <p className="mtlPara">
                    14K Metal Credit :{" "}
                    {userData &&
                      userData.labels &&
                      userData.labels.length > 0 && (
                        <>
                          {userData.labels.map((label, index) => {
                            if (label !== "14K Metal Credit") {
                              return null; // Skip rendering "Order date" here
                            }
                            return (
                              <strong className="pltMtl" key={index}>
                                {userData.input_values[index]}
                              </strong>
                            );
                          })}
                        </>
                      )}
                  </p>
                  <p className="mtlPara">
                    18K Metal Credit :{" "}
                    {userData &&
                      userData.labels &&
                      userData.labels.length > 0 && (
                        <>
                          {userData.labels.map((label, index) => {
                            if (label !== "18K Metal Credit") {
                              return null; // Skip rendering "Order date" here
                            }
                            return (
                              <strong className="pltMtl" key={index}>
                                {userData.input_values[index]}
                              </strong>
                            );
                          })}
                        </>
                      )}
                  </p>
                </span>
              </li>
            </ul>
          )}

          <div className="signBox">
            <h3>{representiveValue}:</h3>
            {Number(status) !== 1 ? (
              <div className="signInner">
                <div>
                  <SignatureCanvas
                    ref={signatureRef}
                    canvasProps={{
                      width: canvasSize.width,
                      height: canvasSize.height,
                      className: "signatureCanvas",
                    }}
                  />
                  <button onClick={handleClear}>Clear</button>
                  <button onClick={handleSave}>Save</button>
                </div>
              </div>
            ) : (
              <img
                src={`https://cliqestimatebuilder.com/waiver_admin/${signImage}`}
                alt={`signed image`}
                className="upImg"
              />
            )}

            <h4>Customer Signature</h4>
            <h5>
              {representiveValue} <span className="dteVale">{dateForShow}</span>
            </h5>
            {Number(status) !== 1 ? (
              <>
                {loading ? (
                  <button className="continueBtn" disabled>
                    Please wait...
                  </button>
                ) : (
                  <button
                    className="continueBtn"
                    onClick={() => onFinalSubmit()}
                  >
                    Submit
                  </button>
                )}
                {validationMsg ? (
                  <span className="lgnStatus prevStus alrt">
                    {validationMsg}
                  </span>
                ) : null}
                {successMsg ? (
                  <span className="lgnStatus prevStus alrt">{successMsg}</span>
                ) : null}

                {/* <Link className="cntMe">
                  Have someone contact me to discuss details further
                </Link> */}
              </>
            ) : (
              <span className="lgnStatus prevStus alrt">
                Submitted successfully
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewForm;
